<template>
  <v-card flat dense>
    <v-card-title
      >{{ form.el.type }}
      <v-spacer></v-spacer>
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle class="pb-3"></v-card-subtitle>
    <v-card-text>
      <language-tabs
        ref="languageTabs"
        v-model="form.el.translations"
        #default="{ translation, index, language, currentLocale, on, ...other }"
        eager
      >
        <component
          :is="componentName"
          :value="{
            ...translation,
            items: (form.el.items || []).map(item =>
              item.translations.find(
                subitem => subitem.language_id === language.id
              )
            )
          }"
          :language-id="language.id"
          :locale="currentLocale"
          v-bind="other"
          v-on="on"
          @updateItem="
            data => {
              form.el.items[data.key].translations[index][data.field] =
                data.value;
              emitter();
            }
          "
          @input="updateValue(`el.translations[${index}]`, $event)"
          @removeItem="removeItem"
        ></component>
      </language-tabs>
      <v-row class="pt-5 pl-2">
        <v-col>
          <slot name="additional" />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <slot name="buttons" />
    </v-card-actions>
  </v-card>
</template>

<script>
import LanguageTabs from '@/modules/_global/_components/LanguageTabs.vue';
import formEditable from '@/modules/_global/mixins/form-editable';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'EditForm',

  components: {
    LanguageTabs
  },

  mixins: [formEditable, i18nRefreshData],

  props: {
    formPath: {
      type: String,
      required: true
    }
  },

  data: () => ({}),

  computed: {
    componentName() {
      return () => import(`@/${this.formPath}`);
    }
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },
    removeItem(key) {
      this.$emit('removeItem', key);
    }
  }
};
</script>

<style scoped></style>
